import React from 'react'

import Layout from '../components/Layout'
import Banner from '../components/Banner'
import { convertTimestamp } from '../components/Helpers'
import SEO from '../components/Seo'

import { InlineForm, InlineTextarea } from 'react-tinacms-inline'
import { InlineWysiwyg } from 'react-tinacms-editor'
import { useJsonForm, DeleteAction } from 'gatsby-tinacms-json'
import { usePlugin } from 'tinacms'


const Press = ({ data }) => {

    const { post, images } = data;
    const formConfig = {
        id: 1,
        actions: [DeleteAction],
        label: 'Edit Blog Post',
        fields: [
            {
                label: 'SEO Title',
                name: 'rawJson.seo_title',
                component: 'textarea'
            },
            {
                label: 'Meta Description',
                name: 'rawJson.meta_description',
                component: 'textarea'
            },
            {
                label: 'Featured Image',
                name: 'rawJson.image',
                component: 'image',
                parse: media => {
                    if (!media) return ''
                    const path = media.directory.split('/content/')[1]
                    return `../${path}${media.filename}`
                },
                uploadDir: () => `/content/assets/`,
                previewSrc: (src, path, formValues) => {
                    const edge = images.edges.find((element) => {
                        return (element.node.fluid.src.split('/').pop() === src.replace(/^.*[\\\/]/, ''));
                    })
                    if (edge) {
                        return edge.node.fluid.src
                    }
                    return ''
                },
            },
            {
                label: 'Author',
                name: 'rawJson.author',
                component: 'text'
            },
            {
                name: 'rawJson.published',
                component: 'toggle',
                label: 'Status',
                toggleLabels: {
                    true: 'Published',
                    false: 'Draft',
                },
            },
        ]
    }


    const [modifiedData, form] = useJsonForm(post, formConfig)
    usePlugin(form)

    return (
        <>
            <SEO title={modifiedData.seoTitle} description={modifiedData.metaDescription} />
            <Layout>
                <div className="mainContainer">
                    <InlineForm form={form} >
                        <article>
                            <div className="container article-container">
                                <p className="center">FOR IMMEDIATE RELEASE: {convertTimestamp(modifiedData.createdAt)}</p>
                                <h1 className="sized"><InlineTextarea name="rawJson.title" /></h1>
                                <InlineWysiwyg
                                    sticky
                                    name="rawJson.body"
                                    format="html"
                                    imageProps={{
                                        // Generate the frontmatter value based on the filename
                                        parse: (media) => {
                                            if (!media) return ""
                                            return `/images/${media.filename}`
                                        },
                                        // Decide the file upload directory for the post
                                        uploadDir: () => `/static/images/`,
                                        previewSrc(src, path, formValues) {
                                            return src
                                        },
                                    }}
                                >
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: modifiedData.body,
                                        }}
                                    />
                                </InlineWysiwyg>
                            </div>
                        </article>
                    </InlineForm>
                </div>
                <Banner />
            </Layout>
        </>
    )
}

export default Press

export const pageQuery = graphql`
query ($slug: String!){
    images: allImageSharp {
        edges {
            node {
                fluid(maxWidth: 1200) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
    post: postsJson (slug:{ eq: $slug }){
        title
        body
        createdAt: created_at
        image {
            relativePath
            childImageSharp {
                fluid(maxWidth: 1200) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        imageAlt: image_alt
        published
        seoTitle: seo_title
        metaDescription: meta_description
        slug
        excerpt
        author

        rawJson
        fileRelativePath
    }
}`